async function e(e,r){return e.request({method:"wallet_requestPermissions",params:[r]})}export{e as requestPermissions};
